import React, { FC, ReactNode } from 'react';
import { ImagesFragment, RentalUnitTypeEnum } from '../generated/graphql';
import { groupImagesByCategory } from '../utils/groupImagesByCategory';
import Carousel from './designsystem/Carousel';
import PhotoCategory from './PhotoCategory';

interface Props {
    data: ImagesFragment[];
    onCategoryClick: (categoryIndex: number) => void;
    title?: ReactNode;
    rentalUnitType?: string;
}

const PhotoCategoryGallery: FC<React.PropsWithChildren<Props>> = ({ data, onCategoryClick, title, rentalUnitType }) => {
    let groupedImages = groupImagesByCategory(data);
    if (rentalUnitType === RentalUnitTypeEnum.Room) {
        const preferredCategories = [
            'FRONT',
            'LIVING_ROOM',
            'KITCHEN',
            'BEDROOM',
            'BATHROOM',
            'OUTDOOR',
            'VIEW',
            'FACILITIES',
            'ENTRANCE',
            'SURROUNDINGS',
            'FLOOR_PLAN',
            'OTHER',
        ];

        groupedImages = groupedImages.sort((a, b) => {
            const indexA = preferredCategories.indexOf(a.category);
            const indexB = preferredCategories.indexOf(b.category);

            if (indexA === -1 && indexB === -1) {
                return 0;
            }
            if (indexA === -1) {
                return 1;
            }
            if (indexB === -1) {
                return -1;
            }
            return indexA - indexB;
        });
    }

    const rooms = groupedImages.map(({ category, images }, index) => {
        const image = images[0];
        if (!image?.jpegTile || !image?.webpTile) {
            return null;
        }
        return (
            <PhotoCategory
                key={category}
                category={category}
                jpeg={image.jpegTile}
                webp={image.webpTile}
                count={images?.length}
                onClick={() => {
                    onCategoryClick(index);
                }}
            />
        );
    });

    return (
        <Carousel title={title} continuous>
            {rooms}
        </Carousel>
    );
};

export default PhotoCategoryGallery;
